import { Injectable } from "@angular/core";
import {
  ExportMediaOptions,
  GetMediaOptions,
  MediaType,
  PatientMediaDetailsModel,
  PatientMediaModel,
  PatientMediaModelPagedResult,
} from "@types";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

export interface UploadMediaOptions {
  file: File;
  data: {
    description?: string;
    isImported?: boolean;
    mediaType?: MediaType;
    media: {
      mimeType?: string;
      /** Recording duration in milliseconds. Only required for audio files. */
      duration?: number;
    };
  };
}

@Injectable({
  providedIn: "root",
})
export class MediaService {
  public constructor(private apiService: ApiService) {}

  public getMedia(
    options: GetMediaOptions
  ): Observable<PatientMediaModelPagedResult> {
    const path = `/api/v2/Media`;
    return this.apiService.get<PatientMediaModelPagedResult>({
      path,
      queryParams: { ...options },
    });
  }

  public export(
    options: ExportMediaOptions
  ): Observable<PatientMediaDetailsModel> {
    const path = `/api/v2/Media/${options.mediaId}/export`;
    return this.apiService.post<PatientMediaDetailsModel>({
      path,
      body: options.request,
    });
  }

  public uploadMedia(
    options: UploadMediaOptions
  ): Observable<PatientMediaModel> {
    const path = `/api/v2/media`;

    const formData = new FormData();
    formData.append("file", options.file, options.file.name);
    formData.append("data", JSON.stringify(options.data));

    return this.apiService.post({
      path,
      body: formData,
    });
  }
}
